import { render, staticRenderFns } from "./OrnamentHistory2.vue?vue&type=template&id=45aac0e2&scoped=true"
import script from "./OrnamentHistory2.vue?vue&type=script&lang=js"
export * from "./OrnamentHistory2.vue?vue&type=script&lang=js"
import style0 from "./OrnamentHistory2.vue?vue&type=style&index=0&id=45aac0e2&prod&lang=less&scoped=true"
import style1 from "./OrnamentHistory2.vue?vue&type=style&index=1&id=45aac0e2&prod&lang=less"
import style2 from "./OrnamentHistory2.vue?vue&type=style&index=2&id=45aac0e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aac0e2",
  null
  
)

export default component.exports